<template>
  <div class="electronic-over-view">
    <!--<el-tabs type="card" v-model="buildingOnPage">-->
    <!--<el-tab-pane v-for="buildItem in buildingList" :label="buildItem.name" :name="buildItem.code" :key="buildItem.code">-->

    <!--</el-tab-pane>-->

    <div class="electronic-over-view-line" style="margin: 40px 0; padding: 0 40px">
      <div class="electronic-person-count-box" style="background: linear-gradient(#1dcbbb, #1dcbbb99)">
        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>
        <div class="electronic-person-count-box-info" style="display: flex; justify-content: space-between; align-items: center">
          <div style="flex: 1">
            <div class="electronic-person-count">{{ steamMeterTotalCount || 0 }}</div>
            <div class="electronic-person-tip">蒸汽表总数</div>
          </div>
          <div style="flex: 1">
            <div class="electronic-person-count">{{ steamMeterOffCount || 0 }}</div>
            <div class="electronic-person-tip">离线蒸汽表</div>
          </div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#12c9e4, #12c9e499)">
        <i class="el-icon-damai-shebei2"></i>
        <div class="electronic-person-count-box-info" style="display: flex; justify-content: space-between; align-items: center">
          <div style="flex: 1">
            <div class="electronic-person-count">{{ steamManagerTotalCount || 0 }}</div>
            <div class="electronic-person-tip">集中器总数</div>
          </div>
          <div style="flex: 1">
            <div class="electronic-person-count">{{ steamManagerOffCount || 0 }}</div>
            <div class="electronic-person-tip">离线集中器</div>
          </div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#3e78f4, #3e78f499)">
        <i class="el-icon-damai-liuliang"></i>
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-count">{{ steamQuantityTitle || 0 }} <span class="electronic-person-count-unit">吨</span></div>
          <div class="electronic-person-tip">当月蒸汽量</div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#ff9f72, #ff9f7299)">
        <i class="el-icon-damai-yingshoujine"></i>
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-count">{{ steamFeiTitle || 0 }} <span class="electronic-person-count-unit">元</span></div>
          <div class="electronic-person-tip">当月蒸汽费</div>
        </div>
      </div>
    </div>

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px">-->
    <!--        <div class="electronic-over-view-line-left">-->
    <!--          <common-ring commonRingId="ammeterRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='ammeterTitle' :ringData='ammeterInfo' />-->
    <!--          <common-ring commonRingId="controllerRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='controllerTitle' :ringData='controllerInfo' />-->
    <!--        </div>-->
    <!--        <div class="electronic-over-view-line-right">-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="steamQuantityRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='steamQuantityTitle' :ringData='steamQuantityInfo' />-->
    <!--          </div>-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="steamFeiRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='steamFeiTitle' :ringData='steamFeiInfo' />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);position: relative;">-->
    <!--        <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--          <el-switch-->
    <!--            v-model="steamityRadio"-->
    <!--            active-text="年度"-->
    <!--            inactive-text="月度">-->
    <!--          </el-switch>-->
    <!--        </div>-->
    <!--        <common-line style="z-index: 1000" lineId='steamityLine' :height='"280px"' :lineTitle='steamityTitle' :legendData="steamityLegendData" :xAxis="steamityXAxis" :yAxis='steamityYAxis' :series='steamitySeries' />-->
    <!--      </div>-->

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); padding: 10px 10px; position: relative">
      <chart-time-select @getData="getSteamLevleStatistics" />
      <common-line style="z-index: 1000" lineId="steamLevelLine" :height="'280px'" :lineTitle="steamLevelTitle" :legendData="steamLevelLegendData" :xAxis="steamLevelXAxis" :yAxis="steamLevelYAxis" :series="steamLevelSeries" />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); padding: 10px 10px; position: relative">
      <chart-time-select @getData="getSteamStatistics" />
      <common-line style="z-index: 1000" lineId="steamLine" :height="'280px'" :lineTitle="steamTitle" :legendData="steamLegendData" :xAxis="steamXAxis" :yAxis="steamYAxis" :series="steamSeries" />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); position: relative">
      <chart-time-select @getData="getSteamRechargeStatistics" />
      <common-line style="z-index: 1000" lineId="steamityLine" :height="'280px'" :lineTitle="steamRechargeStatisticsTitle" :legendData="steamRechargeStatisticsLegendData" :xAxis="steamRechargeStatisticsXAxis" :yAxis="steamRechargeStatisticsYAxis" :series="steamRechargeStatisticsSeries" />
    </div>

    <!--<div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #eeeeee;border-radius: 10px;padding: 10px 10px;position: relative;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="steamityFeiLineRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='steamityFeiLine' :height='"280px"' :lineTitle='steamityFeiLineTitle' :legendData="steamityFeiLineLegendData" :xAxis="steamityFeiLineXAxis" :yAxis='steamityFeiLineYAxis' :series='steamityFeiLineSeries' />-->
    <!--</div>-->

    <!--<div class="visitor-over-view-line" style="height: 300px;margin: 30px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="steamityPayRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='steamityPayLine' :height='"280px"' :lineTitle='steamityPayTitle' :legendData="steamityPayLegendData" :xAxis="steamityPayXAxis" :yAxis='steamityPayYAxis' :series='steamityPaySeries' />-->
    <!--</div>-->

    <!--<div class="electronic-over-view-line">-->
    <!--<div class="electronic-over-view-line-left" style="justify-content: flex-start;flex-direction: column;height: 270px;display: block">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>欠费住户 ({{arrearsTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="arrearsCurrentChange"-->
    <!--:page-size="arrearsPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="arrearsTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="arrearsTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--</el-table>-->
    <!--</div>-->
    <!--<div class="electronic-over-view-line-right" style="justify-content: flex-start;flex-direction: column;height: 270px">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>余额不足住户 ({{approachingPaymentTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="approachingPaymentCurrentChange"-->
    <!--:page-size="approachingPaymentPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="approachingPaymentTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="approachingPaymentTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->

    <!--</el-table>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
import { api } from '../../api/SteamManagement'
import { errorHandler } from '../../../utils/errorHandler'
import ControllerPie from '../../../components/Echarts/Pie/Pie/controllerPie'
import AmmeterPie from '../../../components/Echarts/Pie/Pie/ammeterPie'
import ElectronicStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar'
import ElectronicMonthStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar'
import CommonLine from '../../../components/Echarts/Line/commonLine'
import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
import ChartTimeSelect from '../../../components/Echarts/ChartTimeSelect/ChartTimeSelect'

export default {
  components: {
    ChartTimeSelect,
    CommonRing,
    CommonLine,
    ElectronicMonthStackingBar,
    ElectronicStackingBar,
    AmmeterPie,
    ControllerPie,
  },
  name: 'over-view',
  data() {
    return {
      steamSceneList: [],
      // 楼栋
      buildingOnPage: '',
      buildingList: [],

      steamLevelTitle: '级别蒸汽量统计',
      steamLevelLegendData: [],
      steamLevelXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamLevelYAxis: [
        {
          type: 'value',
          name: '蒸汽量(吨)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamLevelSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      steamRadio: false,
      steamTitle: '场景蒸汽量统计',
      steamLegendData: [],
      steamXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamYAxis: [
        {
          type: 'value',
          name: '蒸汽量(吨)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      commonColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC'],
      commonRingLegend: {
        left: 'center',
        bottom: -5,
      },
      ammeterTitle: '蒸汽表',
      ammeterInfo: [],
      controllerTitle: '控制器',
      controllerInfo: [],
      steamQuantityTitle: '',
      steamQuantityInfo: [],
      steamFeiTitle: '',
      steamFeiInfo: [],

      // 欠费住户
      arrearsPageNum: 1,
      arrearsPageSize: 5,
      arrearsTotal: 0,
      arrearsTableData: [],

      // 临近缴费住户
      approachingPaymentPageNum: 1,
      approachingPaymentPageSize: 5,
      approachingPaymentTotal: 0,
      approachingPaymentTableData: [],

      steamityRadio: false,
      steamityTitle: '蒸汽量统计',
      steamityLegendData: [],
      steamityXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamityYAxis: [
        {
          type: 'value',
          name: '蒸汽量(吨)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamitySeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      steamRechargeStatisticsTitle: '充值统计',
      steamRechargeStatisticsLegendData: [],
      steamRechargeStatisticsXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamRechargeStatisticsYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamRechargeStatisticsSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      steamityFeiLineRadio: false,
      steamityFeiLineTitle: '蒸汽费统计',
      steamityFeiLineLegendData: [],
      steamityFeiLineXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamityFeiLineYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamityFeiLineSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      steamityPayRadio: false,
      steamityPayTitle: '充值统计',
      steamityPayLegendData: [],
      steamityPayXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      steamityPayYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      steamityPaySeries: [],

      steamMeterTotalCount: 0,
      steamMeterOffCount: 0,

      steamManagerTotalCount: 0,
      steamManagerOffCount: 0,

      steamFeiLineLegendData: [],
      steamFeiLineXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
    }
  },
  created() {
    // this.getBuildingList()
    // this.getArrearsList()
    // this.getApproachingPaymentList()
    // this.getRechargeStatistics(1)
    this.getSteamityStatistics(1)
    this.getCurrentMonthSteamity()
    this.getSteamMeterDeviceOverview()
    this.getSteamControlDeviceOverview()
    this.getSteamSceneList()
  },
  methods: {
    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.unshift({
              code: '',
              name: '全部',
            })
            this.buildingList = data
          }
        })
        .catch(errorHandler('获取楼栋列表失败'))
    },

    // 蒸汽表
    getSteamMeterDeviceOverview() {
      this.$axios
        .post(api.getSteamMeterDeviceOverview, {})
        .then((res) => {
          let data = res.data.data
          let onLine = { value: data.onlineCount || 0, name: '在线' }
          let offLine = { value: data.offlineCount || 0, name: '离线' }
          this.ammeterInfo = [onLine, offLine]
          this.ammeterTitle = `蒸汽表(${data.totalCount})`

          this.steamMeterTotalCount = data.totalCount
          this.steamMeterOffCount = data.offlineCount
        })
        .catch(errorHandler('获取蒸汽表数据失败'))
    },

    // 集中器
    getSteamControlDeviceOverview() {
      this.$axios
        .post(api.getSteamControlDeviceOverview, {})
        .then((res) => {
          let data = res.data.data
          let onLine = { value: data.onlineCount || 0, name: '在线' }
          let offLine = { value: data.offlineCount || 0, name: '离线' }
          this.controllerInfo = [onLine, offLine]
          this.controllerTitle = `控制器(${data.totalCount})`

          this.steamManagerTotalCount = data.totalCount
          this.steamManagerOffCount = data.offlineCount
        })
        .catch(errorHandler('获取集中器数据失败'))
    },

    getSteamRechargeStatistics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getSteamRechargeStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let seriesData = []
          data.map((v) => {
            seriesData.push(v.steamInvoicingMoney)
            xData.push(v.time)
          })
          this.steamRechargeStatisticsXAxis.data = xData
          this.steamRechargeStatisticsSeries = [
            {
              name: '',
              type: 'line',
              stack: '总量',
              // areaStyle: {},
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#00A0E6',
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00A0E6',
                  },
                  {
                    offset: 1,
                    color: '#ffe',
                  },
                ]),
              },
              data: seriesData,
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 欠费
    arrearsCurrentChange(val) {
      this.arrearsPageNum = val
      this.getArrearsList()
    },

    // 获取欠费住户
    getArrearsList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: '1',
          pageNum: this.arrearsPageNum,
          pageSize: this.arrearsPageSize,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.arrearsTableData = data.list
            this.arrearsTotal = data.total
          }
        })
        .catch(errorHandler('获取欠费住户失败'))
    },

    // 欠费
    approachingPaymentCurrentChange(val) {
      this.approachingPaymentPageNum = val
      this.getApproachingPaymentList()
    },

    // 获取临近缴费住户
    getApproachingPaymentList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: '2',
          pageNum: this.approachingPaymentPageNum,
          pageSize: this.approachingPaymentPageSize,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.approachingPaymentTableData = data.list
            this.approachingPaymentTotal = data.total
          }
        })
        .catch(errorHandler('获取临近缴费住户失败'))
    },

    getCurrentMonthSteamity() {
      this.$axios
        .get(`${api.getCurrentMonthSteamity}`, {})
        .then((res) => {
          let details = res.data.data.details
          console.log(details)
          let steamQuantityInfo = []
          let steamFeiInfo = []
          let allQuantity = 0
          let allMoney = 0
          if (details) {
            details.map((v) => {
              let steamQuantityObj = {
                name: v.steamSceneName,
                value: v.steamSceneData,
              }
              let steamFeiObj = {
                name: v.steamSceneName,
                value: v.steamSceneMoney,
              }
              allQuantity = parseFloat(allQuantity + v.steamSceneData).toFixed(2)
              allMoney = parseFloat(allMoney + v.steamSceneMoney).toFixed(2)
              steamQuantityInfo.push(steamQuantityObj)
              steamFeiInfo.push(steamFeiObj)
            })
          }
          this.steamQuantityInfo = steamQuantityInfo
          this.steamQuantityTitle = `${res.data.data.totalSteamity}`
          this.steamFeiInfo = steamFeiInfo
          this.steamFeiTitle = `${res.data.data.totalMoney}`
        })
        .catch(errorHandler('获取数据失败'))
    },

    getRechargeStatistics(type) {
      this.$axios
        .get(`${api.getRechargeStatistics}/${type}`, {})
        .then((res) => {
          let data = res.data.data
          let xData = []
          let seriesData = []
          data.map((v) => {
            seriesData.push(v.money)
            if (type === 1) {
              let dateArr = v.date.split('-')
              let showData = `${dateArr[1]}-${dateArr[2]}`
              xData.push(showData)
            } else {
              xData.push(v.date)
            }
          })
          this.steamityPayXAxis.data = xData
          this.steamityPaySeries = [
            {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#00A0E6',
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00A0E6',
                  },
                  {
                    offset: 1,
                    color: '#ffe',
                  },
                ]),
              },
              data: seriesData,
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 蒸汽量统计
    getSteamityStatistics(type, str) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .get(`${api.getSteamityStatistics}/${type}`, {})
        .then((res) => {
          let data = res.data.data
          let xData = []
          let steamitySeriesData = []
          let steamityFeiLineSeriesData = []
          let steamityNameData = []
          let steamitySeries = []
          let steamityFeiLineSeries = []
          data.map((v, i) => {
            if (v.details) {
              if (i === 0) {
                v.details.map((detail) => {
                  steamityNameData.push(detail.steamSceneName)
                })
              }
              v.details.map((detail, detailIndex) => {
                if (!steamitySeriesData[detailIndex]) {
                  steamitySeriesData[detailIndex] = []
                }
                steamitySeriesData[detailIndex].push(detail.steamSceneData)
                if (!steamityFeiLineSeriesData[detailIndex]) {
                  steamityFeiLineSeriesData[detailIndex] = []
                }
                steamityFeiLineSeriesData[detailIndex].push(detail.steamSceneMoney)
              })
              if (type === 1) {
                let dateArr = v.billTime.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.billTime)
              }
            }
          })
          if (data.length > 0) {
            if (data[0].details) {
              for (let k = 0; k < data[0].details.length; k++) {
                steamitySeries[k] = {
                  name: data[0].details[k].steamSceneName,
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: steamitySeriesData[k],
                }
                steamityFeiLineSeries[k] = {
                  name: data[0].details[k].steamSceneName,
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: steamityFeiLineSeriesData[k],
                }
              }
            }
          }

          if (str === 'steamity') {
            this.steamityXAxis.data = xData
            this.steamityLegendData = steamityNameData
            this.steamitySeries = steamitySeries
          } else if (str === 'steamityFeiLine') {
            this.steamityFeiLineXAxis.data = xData
            this.steamityFeiLineLegendData = steamityNameData
            this.steamityFeiLineSeries = steamityFeiLineSeries
          } else {
            this.steamityXAxis.data = xData
            this.steamityFeiLineXAxis.data = xData
            this.steamitySeries = steamitySeries
            this.steamityFeiLineSeries = steamityFeiLineSeries
            this.steamityLegendData = steamityNameData
            this.steamityFeiLineLegendData = steamityNameData
          }
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 级别蒸汽量统计
    getSteamLevleStatistics(type, startTime, endTime) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .post(`${api.getSteamLevelStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let steamSeriesData = []
          let steamNameData = ['一级', '二级', '三级', '四级', '五级']
          let steamSeries = []

          setTimeout(() => {
            data.map((v, i) => {
              steamNameData.map((steamName, steamNameIndex) => {
                if (!steamSeriesData[steamNameIndex]) {
                  steamSeriesData[steamNameIndex] = []
                }
                if (v.steamDetails) {
                  v.steamDetails.map((detail, detailIndex) => {
                    if (!steamSeriesData[steamNameIndex][i]) {
                      steamSeriesData[steamNameIndex][i] = 0
                    }
                    if (detail.level === steamNameIndex + 1) {
                      steamSeriesData[steamNameIndex][i] = detail.steamCommon
                    }
                  })
                } else {
                  steamSeriesData[steamNameIndex][i] = 0
                }
              })
              xData.push(v.time)
            })
            if (data.length > 0) {
              for (let k = 0; k < steamNameData.length; k++) {
                steamSeries[k] = {
                  name: steamNameData[k],
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: steamSeriesData[k],
                }
              }
            }
            this.steamLevelLegendData = steamNameData
            this.steamLevelXAxis.data = xData
            this.steamLevelSeries = steamSeries
          }, 50)
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 获取场景列表
    getSteamSceneList() {
      this.$axios
        .post(api.getSteamSceneList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.steamSceneList = data
          }
        })
        .catch(errorHandler('获取场景列表失败'))
    },

    // 场景蒸汽量统计
    getSteamStatistics(type, startTime, endTime) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .post(`${api.getSteamStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let steamSeriesData = []
          let steamFeiLineSeriesData = []
          let steamNameData = []
          let steamSeries = []
          let steamFeiLineSeries = []
          this.steamSceneList.map((v) => {
            steamNameData.push(v.name)
          })
          setTimeout(() => {
            data.map((v, i) => {
              steamNameData.map((steamName, steamNameIndex) => {
                if (!steamSeriesData[steamNameIndex]) {
                  steamSeriesData[steamNameIndex] = []
                }
                if (!steamFeiLineSeriesData[steamNameIndex]) {
                  steamFeiLineSeriesData[steamNameIndex] = []
                }
                if (v.details) {
                  v.details.map((detail, detailIndex) => {
                    if (!steamSeriesData[steamNameIndex][i]) {
                      steamSeriesData[steamNameIndex][i] = 0
                      steamFeiLineSeriesData[steamNameIndex][i] = 0
                    }
                    if (detail.steamSceneName === steamName) {
                      console.log(detail)
                      steamSeriesData[steamNameIndex][i] = detail.steamSceneData
                      steamFeiLineSeriesData[steamNameIndex][i] = detail.steamSceneMoney
                    }
                  })
                } else {
                  steamSeriesData[steamNameIndex].push(0)
                  steamFeiLineSeriesData[steamNameIndex].push(0)
                }
              })
              if (type === 1) {
                let dateArr = v.billTime.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.billTime)
              }
            })
            if (data.length > 0) {
              for (let k = 0; k < steamNameData.length; k++) {
                steamSeries[k] = {
                  name: steamNameData[k],
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: steamSeriesData[k],
                }
                steamFeiLineSeries[k] = {
                  name: steamNameData[k],
                  type: 'line',
                  stack: steamNameData[k],
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: steamFeiLineSeriesData[k],
                }
              }
            }
            setTimeout(() => {
              this.steamXAxis.data = xData
              this.steamFeiLineXAxis.data = xData
              this.steamSeries = steamSeries
              this.steamFeiLineSeries = steamFeiLineSeries
              this.steamLegendData = steamNameData
              this.steamFeiLineLegendData = steamNameData
            }, 50)
          }, 50)
        })
        .catch(errorHandler('获取数据失败'))
    },
  },

  watch: {
    // steamityPayRadio (val) {
    //   if (!val) {
    //     this.getRechargeStatistics(1)
    //   } else {
    //     this.getRechargeStatistics(2)
    //   }
    // },
    // steamityRadio (val) {
    //   if (!val) {
    //     this.getEsteamityStatistics(1, 'steamity')
    //   } else {
    //     this.getEsteamityStatistics(2, 'steamity')
    //   }
    // },
    // steamityFeiLineRadio (val) {
    //   if (!val) {
    //     this.getEsteamityStatistics(1, 'steamityFeiLine')
    //   } else {
    //     this.getEsteamityStatistics(2, 'steamityFeiLine')
    //   }
    // }
  },
}
</script>

<style lang="less">
.electronic-over-view {
  padding: 10px 2%;
  .electronic-over-view-line {
    display: flex;
    justify-content: space-between;
    .electronic-person-count-box {
      width: 23%;
      height: 160px;
      padding: 10px 10px;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      i {
        width: 30%;
        font-size: 48px;
      }
      .electronic-person-count-box-info {
        width: 70%;
        text-align: left;
        .electronic-person-count {
          font-size: 36px;
          font-weight: 600;
          word-wrap: break-word;
          .electronic-person-count-unit {
            font-size: 12px;
          }
        }
        .electronic-person-tip {
          font-size: 16px;
        }
      }
    }
    .electronic-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }
    .electronic-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }
      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #ff0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/OverView/OverView.vue